<template>
  <section class="section" style="margin-bottom: 100px; margin-top: 1em">
    <div class="container">
      <div class="columns is-multiline">
        <revolve data-aos-duration="1000"></revolve>
        <selma data-aos-duration="1000"></selma>
        <peach data-aos-duration="750"></peach>
        <walkers data-aos-duration="1000"></walkers>
        <bebe data-aos-duration="750"></bebe>
        <cupcake data-aos-duration="1000"></cupcake>
        <pitko data-aos-duration="750"></pitko>
        <toast data-aos-duration="1000"></toast>
        <bug data-aos-duration="750"></bug>
        <oe data-aos-duration="1000"></oe>
        <smallChair data-aos-duration="750"></smallChair>
        <emBasket data-aos-duration="1000"></emBasket>
        <mai data-aos-duration="750"></mai>
        <timjam data-aos-duration="1000"></timjam>
        <wimble data-aos-duration="750"></wimble>
      </div>
    </div>
  </section>
</template>

<script>
import Toast from '@/components/portfolio/Toast.vue'
import Cupcake from '@/components/portfolio/Cupcake.vue'
import Pitko from '@/components/portfolio/Pitko.vue'
import Peach from '@/components/portfolio/Peach.vue'
import Walkers from '@/components/portfolio/Walkers.vue'
import Bebe from '@/components/portfolio/Bebe.vue'
import Bug from '@/components/portfolio/Bug.vue'
import Wimble from '@/components/portfolio/Wimble.vue'
import Timjam from '@/components/portfolio/Timjam.vue'
import Mai from '@/components/portfolio/Mai.vue'
import EmBasket from '@/components/portfolio/Em_basket.vue'
import Small from '@/components/portfolio/Small.vue'
import Oe from '@/components/portfolio/Oe.vue'
import Selma from '@/components/portfolio/Selma.vue'
import Revolve from '@/components/portfolio/Revolve.vue'

import AOS from 'aos'

AOS.init({
  duration: 1000
})

export default {
  components: {
    Toast: Toast,
    Cupcake: Cupcake,
    Walkers: Walkers,
    Bebe: Bebe,
    Pitko: Pitko,
    Peach: Peach,
    Bug: Bug,
    wimble: Wimble,
    timjam: Timjam,
    mai: Mai,
    emBasket: EmBasket,
    smallChair: Small,
    oe: Oe,
    selma: Selma,
    revolve: Revolve
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style></style>



// WEBPACK FOOTER //
// src/components/Home.vue